// extracted by mini-css-extract-plugin
export default {"button__collapseIcon":"Sort_button__collapseIcon__BZ00H"};